import { gql } from "graphql-request";
import { CollectionDTO, ErrorMetadata, ID } from "../../Types";

export const GET_PARTS_FOR_PROJECT_QUERY = gql`
  query GetPartsForProjectQuery($projectId: ID!, $pageSize: Int, $page: Int) {
    projectItems(
      page: $page
      pageSize: $pageSize
      projectId: $projectId
      itemType: Part
    ) {
      collection {
        createdAt
        id
        instanceParameters
        item
        quantity
        type
        updatedAt
        obsolete
        createChange {
          id
          event
          itemId
          itemType
          objectUser {
            id
            email
            displayName
            avatarUrl
          }
          objectUserId
          user {
            id
            email
            displayName
            avatarUrl
          }
        }
      }
    }
  }
`;

export type GetPartsItemCreateChangeDTO = {
  id: ID;
  event: string;
  itemId: ID;
  itemType: string;
  objectUser: {
    id: ID;
    email: string;
    displayName: string;
    avatarUrl: string;
  };
  objectUserId: ID;
  user: {
    id: ID;
    email: string;
    displayName: string;
    avatarUrl: string;
  };
};

export type GetPartsItemForProjectDTO = {
  id: ID;
  name: string;
  category: string;
  sub_category1: string;
  sub_category2: string;
  part_number: string;
  status: string;
  description: string;
  updated_at: string;
  weight: number | string;
  width: number | string;
  height: number | string;
  length: number | string;
  regional_unit_prices: {
    US: number;
  };
  computed_regional_unit_prices: {};
  unit_price: number | string;
  image: {
    url: string;
    thumb: {
      url: string;
    };
  };
};

export type GetPartsForProjectDTO = {
  createdAt: string;
  id: ID;
  instanceParameters: {};
  obsolete: boolean;
  item: GetPartsItemForProjectDTO;
  quantity: number;
  type: string;
  updatedAt: string;
  createChange: GetPartsItemCreateChangeDTO;
};

export type GetPartsForProjectCollectionDTO = CollectionDTO<
  GetPartsForProjectDTO,
  "projectItems"
>;

export type GetPartsForProjectQueryParams = {
  projectId: ID;
  pageSize: number;
  page: number;
};

export const SAVE_PROJECT_PART_MUTATION = gql`
  mutation SaveProjectPartMutation(
    $projectId: ID!
    $partId: ID!
    $quantity: Int!
  ) {
    projectItemSave(
      input: {
        projectId: $projectId
        itemType: Part
        itemId: $partId
        quantity: $quantity
      }
    ) {
      projectItem {
        id
      }
      errors {
        title
        message
      }
    }
  }
`;

export type SaveProjectPartMutationDTO = {
  projectItemSave: {
    projectItem: {
      id: string;
    };
  };
} & ErrorMetadata;

export type SaveProjectPartMutationParams = {
  projectId: ID;
  partId: ID;
  quantity: number;
};
